.error{font-size:12px}
/*# sourceMappingURL=mfa.component-B7YNFIJ6.css.map */
